import { GigType } from "model/Gig";
import type {
  ScheduleApiShiftItem,
  ScheduleApiWorkerRow,
} from "web-apps/company/components/schedule/types/schedule.types";

export interface DayTeam {
  readonly id: number;
  readonly name: string;
  readonly shifts: readonly DayShift[];
}

export interface DayShift {
  readonly endTime: string;
  readonly gigType?: GigType;
  readonly id: number;
  readonly isWorker: boolean;
  readonly role: string;
  readonly startTime: string;
  readonly workerExternalId: string;
  readonly workerName: string | null;
}

interface GroupScheduleDayShiftsParams {
  readonly rows: ScheduleApiWorkerRow[];
}

interface ToDayShiftParams {
  readonly item: ScheduleApiShiftItem;
  readonly row: ScheduleApiWorkerRow;
}

interface MutableDayTeam {
  id: number;
  name: string;
  shifts: DayShift[];
}

function toDayShift(params: ToDayShiftParams): DayShift {
  return {
    endTime: params.item.endTime,
    gigType: params.item.gigType,
    id: params.item.gigShiftId,
    isWorker:
      Boolean(params.item.workerExternalId) ||
      params.item.workerId != null ||
      params.row.isWorker !== false,
    role: params.row.text2?.trim() || params.row.text?.trim() || "",
    startTime: params.item.startTime,
    workerExternalId: params.item.workerExternalId ?? params.row.externalId,
    workerName:
      params.item.workerName?.trim() ||
      (params.row.isWorker !== false ? params.row.heading : null),
  };
}

export function groupScheduleDayShifts(
  params: GroupScheduleDayShiftsParams,
): DayTeam[] {
  const groups = new Map<number, MutableDayTeam>();
  params.rows.forEach((row) => {
    row.items.forEach((item) => {
      const team = groups.get(item.workGroupId) ?? {
        id: item.workGroupId,
        name: item.workGroupName,
        shifts: [],
      };
      team.shifts.push(toDayShift({ item, row }));
      groups.set(item.workGroupId, team);
    });
  });
  return Array.from(groups.values());
}
